import { render, staticRenderFns } from "./TeacherManagement.vue?vue&type=template&id=f9c6f0ea&scoped=true&"
import script from "./TeacherManagement.vue?vue&type=script&lang=js&"
export * from "./TeacherManagement.vue?vue&type=script&lang=js&"
import style0 from "./TeacherManagement.vue?vue&type=style&index=0&id=f9c6f0ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c6f0ea",
  null
  
)

export default component.exports